import { createSlice } from "@reduxjs/toolkit";

/**
 * Whether the vendor terms window is asked for. The dashboard's New Vendor
 * Terms banner draws the window (VendorSetupBanner), and more than its own
 * button opens it: an accept-order the backend refuses for want of the
 * terms opens them right on the page the vendor is on
 * (useOpenVendorTermsOnRefusal; Tyler, 2026-10-10, as the app's sheet
 * opens in place). So the flag lives here and any page can dispatch it, as
 * the support chat's does. Closing the window clears it.
 */
type VendorTermsState = {
  asked: boolean;
};

const initialState: VendorTermsState = {
  asked: false,
};

export const vendorTermsSlice = createSlice({
  name: "vendorTerms",
  initialState,
  reducers: {
    askVendorTerms: (state) => {
      state.asked = true;
    },
    closeVendorTerms: (state) => {
      state.asked = false;
    },
  },
});

export const { askVendorTerms, closeVendorTerms } = vendorTermsSlice.actions;

export default vendorTermsSlice.reducer;
